module.exports = __webpack_public_path__ + "static/slide3-6ff617ddf11b78c63ed2afa6ae79542a.png";